import { Chip } from "@mui/material"

export const StatusPill = ({ isActive }: { isActive: boolean }) => {
    return (
        <Chip
            label={isActive ? "Active" : "Inactive"}
            sx={{
                backgroundColor: isActive ? "#A6C48A" : "transparent",
                color: isActive ? "#000" : "#162C1F",
                marginRight: 8,
                marginBottom: 8,
                margin: "4px",
                borderRadius: '16px',
                fontWeight: 'bold',
                fontSize: '0.8rem',
                border: isActive ? "none" : "2px solid #162C1F",
            }}
        />
    );
};